import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const StyledHeader = styled.header`
  width: 100%;
  padding: 16px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  background: #0b1622;
  display: flex;
  flex-direction: column;
`

const HeaderTitle = styled.h1`
  font-size: 2rem;
  width: 90vw;
  text-align: left;
  max-width: 800px;
  margin: 0 auto;
  font-family: Major Mono Display;
  text-transform: lowercase;
`

const Header = () => (
  <StyledHeader>
    <HeaderTitle>
      <Link to="/">akira</Link>
    </HeaderTitle>
  </StyledHeader>
)

export default Header
